var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"d":"M2.84,10.15S-3.29,3.78,2.46.08c0,0,.93-.59,2,1.4S5,4.21,4,4.78,3.49,7,4.84,8.43h0C6.08,10,7.59,10.58,8.28,9.67s1.47-1.43,3.34-.09,1.14,2.17,1.14,2.17c-4.39,5.25-9.92-1.6-9.92-1.6Z","style":{"fill":"currentcolor"}}))));
}

Phone.defaultProps = {"viewBox":"0 0 12.89 13.73"};

module.exports = Phone;

Phone.default = Phone;
